
import { Component, Mixins, Watch, Vue } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import ValidateableMixin from '@/mixins/ValidateableMixin';
import { Action } from 'vuex-class';
import { actions } from '@/store/types';
import { UpdateEmailActionType } from '@/types/store/actions';

@Component({
    components: {},
    mixins: [ModelMixin, ValidateableMixin],
})
export default class EmailPopup extends Mixins<ValidateableMixin, ModelMixin<boolean>>(ValidateableMixin, ModelMixin) {
    email = '';

    @Action(actions.UPDATE_EMAIL)
    updateEmail!: UpdateEmailActionType;

    async save(e: Event) {
        e.preventDefault();
        const result = await this.updateEmail(this.email);
        if (result) this.model = false;
    }

    @Watch('model', { immediate: true })
    onModelChange(newValue: boolean, oldValue: boolean) {
        if (newValue && !oldValue) this.email = '';
    }
}
